export const Constants = {
    animationDuration: 300,
};
